import { getName } from 'i18n-iso-countries'

/**
 * Country label shown by the country selectors, e.g. "(FRA) FRANCE".
 *
 * @param {Object} country country from localizeCountries
 * @param {string} codeKey code to prefix: iso_3_code, or iso_2_code for Find in Store
 * @returns {string}
 */
export function formatCountryLabel(country, codeKey = 'iso_3_code') {
  return `(${country[codeKey]}) ${country.name}`
}

/**
 * Countries with their name translated in the given locale and upper-cased, sorted by that name.
 * The locale must already be registered in i18n-iso-countries; without a translation the stored name is kept.
 *
 * @param {Object[]} countries countries with iso_2_code, iso_3_code and name
 * @param {string} locale locale to translate and sort with
 * @returns {Object[]} new country objects; the input is not mutated
 */
export function localizeCountries(countries, locale) {
  // Sort by translated name, so each locale gets its own alphabetical order.
  return countries
    .map((country) => ({ ...country, name: (getName(country.iso_3_code, locale) ?? country.name).toUpperCase() }))
    .sort((first, second) => first.name.localeCompare(second.name, locale))
}
